import { render, staticRenderFns } from "./ButtonDownload.vue?vue&type=template&id=7bbc97b7&scoped=true"
import script from "./ButtonDownload.vue?vue&type=script&lang=ts"
export * from "./ButtonDownload.vue?vue&type=script&lang=ts"
import style0 from "./Button.scss?vue&type=style&index=0&id=7bbc97b7&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bbc97b7",
  null
  
)

export default component.exports